import { createStyles, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { NotificationIcon } from 'src/components/icons';
import { NOTIFICATIONS_PAGE_EMPTY_STATE_LEARN_MORE } from 'src/constants/modulesEmptyStates';
import { useNotificationsCounts } from 'src/hooks/useNotificationsCount';
import { useAppSelector } from 'src/hooks/useStore';
import StandardPage from 'src/legacy/components/UI/StandardPage';
import { useGetInboxNotificationsQuery } from 'src/services/api/inboxApi';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
  }),
);

export const InboxEmptyState = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { data: allInboxNotifications } = useGetInboxNotificationsQuery();
  const clients = useAppSelector((state) => state.clients.clients);
  const ius = useAppSelector((state) => state.users.internalUsers);
  const companyDataMap = useAppSelector(
    (state) => state.clients.companyDataMap,
  );

  const { unreadNotificationCount, readNotificationCount } =
    useNotificationsCounts(
      allInboxNotifications || [],
      [...clients, ...ius],
      companyDataMap,
    );

  // this represents the total number of available notifications that have valid senders

  const allNotificationCount = unreadNotificationCount + readNotificationCount;

  /**
   * generate description of the empty
   * state i.e. when no notification is selected
   */
  const getEmptyStateDescription = () => {
    // there are no notifications
    if (!allNotificationCount) {
      return t(($) => $.page_inbox.empty_state_description);
    }

    // there are no unread notifications
    if (unreadNotificationCount === 0) {
      return 'No unread notifications';
    }
    return `${unreadNotificationCount} unread notification${
      unreadNotificationCount > 1 ? 's' : '' // 'notification` for count:1, 'notifications' for count > 1
    }`;
  };

  const getPageTitle = () => {
    return 'Notifications';
  };

  const getEmptyStateTitle = () => {
    if (!allInboxNotifications?.length) {
      return 'Notifications will show here';
    }
    return getPageTitle();
  };

  const getLearnMoreLink = () => {
    return NOTIFICATIONS_PAGE_EMPTY_STATE_LEARN_MORE;
  };
  return (
    <div className={classes.root}>
      <StandardPage
        hasNavbar={!allNotificationCount}
        pageTitle={!allNotificationCount ? 'Notifications' : undefined}
        topIcon={<NotificationIcon />}
        title={getEmptyStateTitle()}
        desc={getEmptyStateDescription()}
        // show learn more link
        // only when there are no notifications
        learnMoreLinkUrl={
          !allInboxNotifications?.length ? getLearnMoreLink() : ''
        }
      />
    </div>
  );
};
